import React  from 'react';
import QuickSearch from "../QuickSearch";

const ProductQuickSearch = () => {

    return (<QuickSearch OnlyProducts={true}></QuickSearch>);
}

export default ProductQuickSearch